import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-white border-t border-gray-100 py-8 mt-8">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center px-4 gap-2">
        <ul className="flex gap-4 mb-2 md:mb-0 text-gray-500 text-sm">
          <li><button type="button" className="underline hover:text-blue-500 bg-transparent border-none p-0 m-0 cursor-pointer">CGU</button></li>
          <li><button type="button" className="underline hover:text-blue-500 bg-transparent border-none p-0 m-0 cursor-pointer">CGV</button></li>
          <li><button type="button" className="underline hover:text-blue-500 bg-transparent border-none p-0 m-0 cursor-pointer">Politique de confidentialité</button></li>
          <li><Link to="/sitemap" className="underline hover:text-blue-500">Plan du site</Link></li>
        </ul>
        <p className="text-xs text-gray-400">CC BY-NC-SA, Équipe DPN – 2025</p>
        <button className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4 py-2 rounded-lg font-semibold shadow hover:from-blue-600 hover:to-purple-600 transition text-sm">Créer mon compte</button>
      </div>
    </footer>
  );
}

export default Footer; 